module.exports = __webpack_public_path__ + "img/news-slider3-ja.70bf6a3d.jpg";